import { createReducer, on } from '@ngrx/store';
import * as CatalogsActions from './catalogs.actions';
import { CatalogsState } from './catalogs.models';

export const initialState: CatalogsState = {
  catalogs: null,
  loading: false,
  error: null,
};

export const catalogsReducer = (state: CatalogsState | undefined, action: any) => {
  return createReducer(
    initialState,
    on(CatalogsActions.loadCatalogs, (state) => {
      const newState = {
        ...state,
        loading: true,
        error: null,
      };
      return newState;
    }),
    on(CatalogsActions.loadCatalogsSuccess, (state, { catalogs }) => ({
      ...state,
      catalogs,
      loading: false,
      error: null,
    })),
    on(CatalogsActions.loadCatalogsFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(CatalogsActions.resetCatalogs, () => initialState),
  )(state, action);
};
